import {ZeroBet} from "@nolimitcity/slot-game/bin/timelinegameround/game/gameround/presentations/ZeroBet";
import {TimelineLite} from "gsap";
import {BookOfShadowsGameConfig} from "../../BookOfShadowsGameConfig";
import {BookOfShadowsGameMode} from "../../gameMode/BookOfShadowsGameMode";
import {BookOfShadows} from "../../BookOfShadows";
import {BookOfShadowsParsedGameData} from "../../server/data/BookOfShadowsParsedGameData";

export interface IPlayerInteraction {
    baseRows?: string,
    selectedRedraw?: string,
    selectedIndex?: string,
    lockedReel?: string
}

export class BookOfShadowsZeroBet extends ZeroBet {

    /**
     * @inheritDoc
     * @param data
     */
    getAnimation(data: BookOfShadowsParsedGameData): gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax {
        let playerInteraction: IPlayerInteraction = {
            selectedIndex: ((BookOfShadowsGameConfig.instance.ACTIVE_ROWS - 3) + 1) + ""
        };

        const tl: TimelineLite = new TimelineLite(),
            fsLeft: number = ((data.nextMode === BookOfShadowsGameMode.FREESPIN) ? data.freespinsLeft - 1 : -1);

        tl.add(() => {
            if (BookOfShadowsGameConfig.instance.REDRAW_ON_FS_CLICKED) {
                playerInteraction = {
                    selectedRedraw: "2"
                };

                BookOfShadows.api.betHandler.zeroBet(playerInteraction);
            } else if (this.checkForPlayerInteraction(data)) {
                BookOfShadows.api.betHandler.zeroBet(playerInteraction);
            } else {
                BookOfShadows.api.betHandler.zeroBet();
            }
            BookOfShadows.keypad.setZeroBetSpinCounter(fsLeft);
        });

        return tl;
    }

    /**
     * @description Returns true when we need to pass the player interaction in the request.
     * @param data
     */
    private checkForPlayerInteraction(data: BookOfShadowsParsedGameData): boolean {
        return (data.nextMode === BookOfShadowsGameMode.FREESPIN_PICK && !data.wasFeatureBuy);
    }
}